import {
  PLAYLIST_TEST,
  PLAYLIST_CLEAR,
  PLAYLIST_APPEND,
  PLAYLIST_REPLACE,
} from '../actions/PlaylistActions';

function PlaylistReducer(state = [], action) {
  switch (action.type) {
    case PLAYLIST_TEST: {
      return state;
    }
    case PLAYLIST_CLEAR: {
      return [];
    }
    case PLAYLIST_APPEND: {
      const songs = action.songs || [];
      return [...state, ...songs];
    }
    case PLAYLIST_REPLACE: {
      const songs = action.songs || [];
      return songs;
    }
    default: {
      return state;
    }
  }
}

export {
  PlaylistReducer,
};


// WEBPACK FOOTER //
// ./src/reducers/PlaylistReducer.js